/**
 * FetchingOverlay - Background refetch indicator for tables
 * Plan 012: Shared utility component
 */

import { Loader2 } from 'lucide-react'

export function FetchingOverlay() {
  return (
    <div className="absolute inset-0 bg-white/50 dark:bg-neutral-900/50 z-10 flex items-center justify-center">
      <div className="flex items-center gap-2 bg-white dark:bg-neutral-800 px-4 py-2 rounded-lg shadow-lg border border-neutral-200 dark:border-neutral-700">
        <Loader2 className="h-4 w-4 animate-spin text-primary-600" />
        <span className="text-sm text-neutral-700 dark:text-neutral-300">Aktualisiert...</span>
      </div>
    </div>
  )
}
